// Helpers to change class attribute
const updateElementClass = (el, stat, name) =>
	el && el.classList[stat ? 'add' : 'remove'](name);
const updateBodyClass = (stat, name) =>
	updateElementClass(document.body, stat, name);

const updateSetting = state => {
	// updateBodyClass(state.settings.layout.isFixed, 'layout-fixed');
	// updateBodyClass(state.settings.layout.isBoxed, 'layout-boxed');
	// updateBodyClass(state.settings.layout.isCollapsed, 'aside-collapsed');
	// updateBodyClass(
	// 	state.settings.layout.isCollapsedText,
	// 	'aside-collapsed-text'
	// );
	// updateBodyClass(state.settings.layout.isFloat, 'aside-float');
	// updateBodyClass(state.settings.layout.asideHover, 'aside-hover');
	// updateBodyClass(state.settings.layout.offsidebarOpen, 'offsidebar-open');
	// updateBodyClass(state.settings.layout.asideToggled, 'aside-toggled');
	// // layout horizontal
	// updateBodyClass(state.settings.layout.horizontal, 'layout-h');
	// // apply change to the sidebar element
	// updateElementClass(
	// 	document.querySelector('.sidebar'),
	// 	state.settings.layout.asideScrollbar,
	// 	'show-scrollbar'
	// );
	//
};

/*
  Hook into theme change to set a inject a selected theme
*/
const SettingsPlugin = store => {
	// 移除 store.state.db
	// ['db'].forEach(item => delete store.state.settings[item]);

	// wait for dom ready
	document.addEventListener('DOMContentLoaded', () =>
		updateSetting(store.state)
	);

	store.subscribe((mutation, state) => {
		if (
			mutation.type === 'changeSetting' ||
			mutation.type === 'toggleSetting'
		) {
			updateSetting(state);
		}
	});
};

export default SettingsPlugin;
